import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43179ed2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }

import { computed, ref } from "vue";
import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import BrandPattern4 from "@/components/prospect/brandPattern/brandPattern4.vue";
import backgroundComponent from "@/components/common/backgroundComponent.vue";
import ActivePathWrapper from "@/components/common/activePathWrapper.vue";
import SetupWizardModal from "@/components/wizard/setupWizardModal.vue";
import store from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'setup',
  setup(__props) {

const isShowModal = computed(() => {
  return store.getters["SetupWizard/isShowModal"];
});

const createAssessmentShow = ref(isShowModal);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppBarLayout, null, {
    default: _withCtx(({ activeHierarchy }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(BrandPattern4, {
          ref: "animation",
          page: "APPBARLAYOUT"
        }, null, 512),
        _createVNode(backgroundComponent),
        _createVNode(ActivePathWrapper, {
          class: "tw-px-[20px] md:tw-px-[32px] xl:tw-px-[79px]",
          "active-hierarchy": activeHierarchy
        }, null, 8, ["active-hierarchy"]),
        _createVNode(SetupWizardModal, {
          show: createAssessmentShow.value,
          "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((createAssessmentShow).value = $event))
        }, null, 8, ["show"])
      ])
    ]),
    _: 1
  }))
}
}

})